export const sources = {
	webp: "__VITE_ASSET__aLISaAY6NSiJFT$6GdtrfA__ 400w, __VITE_ASSET__Msg57USEadASvSStYSdmzA__ 800w"
};
export const img = {
	src: "__VITE_ASSET__Msg57USEadASvSStYSdmzA__",
	w: 800,
	h: 533
};
export default {
	sources: sources,
	img: img
};
